import { useEffect, useState } from 'react';

/**
 * The page's own load, for the diagnostics overlay (job 2): browsers give no CPU figure, so the stand-in
 * is the page's frame rate and its long frames (over 50 ms between paints) each second, and the match's
 * dropped frames (getVideoPlaybackQuality) over the same second. Measured only while the overlay shows.
 */
export function usePageLoad(open: boolean): string | null {
  const [line, setLine] = useState<string | null>(null);
  useEffect(() => {
    if (!open) return;
    let frames = 0;
    let long = 0;
    let last = performance.now();
    let raf = 0;
    const loop = (t: number) => {
      frames += 1;
      if (t - last > 50) long += 1;
      last = t;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const quality = () => {
      let dropped = 0;
      let total = 0;
      document.querySelectorAll<HTMLVideoElement>('[data-room-match] [data-match-panel] video').forEach((v) => {
        const q = v.getVideoPlaybackQuality?.();
        if (q) { dropped += q.droppedVideoFrames; total += q.totalVideoFrames; }
      });
      return { dropped, total };
    };
    let q0 = quality();
    const id = setInterval(() => {
      const q = quality();
      const match = q.total > q0.total || q.total > 0 ? ` · match dropped ${q.dropped - q0.dropped} of ${q.total - q0.total}` : '';
      setLine(`Page ${frames} fps · long frames ${long}${match}`);
      frames = 0;
      long = 0;
      q0 = q;
    }, 1000);
    return () => { cancelAnimationFrame(raf); clearInterval(id); };
  }, [open]);
  return open ? line : null;
}
